import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';

/**
 * @var string v1
 * @type {string}
 */
const v1 = '/rest/v1.0';
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export default {
  user: {
    'profile_image': `${BASE_URL}${v1}/profile/{username}/images`,
    'basic_info': `${BASE_URL}${v1}/profile/{userName}/info`,
  },
  performer: {
    'update_status': `${BASE_URL}${v1}/studio/{studioOwnerName}/roster/{performerName}`,
    status: `${BASE_URL}${v1}/accounts/{accountHolderUsername}/status`,
  },
  countries: `${BASE_URL}${v1}/blockedCountries/{username}`,
};
